<template>
  <span v-if="active && validChecks.length" class="rights-indicator" :class="'rights-indicator--' + presentation.color" @click.stop @mousedown.stop @keydown.stop>
    <v-tooltip v-model="opened" bottom max-width="440">
      <template #activator="{ on, attrs }">
        <span role="img" tabindex="0" class="rights-indicator__button" v-bind="attrs" :aria-label="accessibleLabel" v-on="on" @click.stop.prevent="opened = !opened" @keydown.enter.stop.prevent="opened = !opened" @keydown.space.stop.prevent="opened = !opened">
          <v-icon :color="presentation.color" size="17">{{ presentation.icon }}</v-icon>
          <v-icon v-if="presentation.individual" :color="presentation.personColor" size="11" class="rights-indicator__person">mdi-account</v-icon>
        </span>
      </template>
      <div class="rights-indicator__tooltip">
        <strong>{{ label || 'Droits' }} · {{ targetLabel }}</strong>
        <div v-for="(line, index) in presentation.lines" :key="index" class="mt-1">{{ line }}</div>
      </div>
    </v-tooltip>
  </span>
</template>

<script>
import { rightsInspection } from './state'
import { normalizeInspectionCheck } from './manager'
import { inspectionPresentation } from './presentation'

let nextOwner = 0
export default {
  name: 'RightsIndicator',
  props: { checks: { type: Array, default: () => [] }, label: { type: String, default: '' } },
  data() { return { inspection: rightsInspection.state, owner: 'rights-indicator-' + ++nextOwner, opened: false } },
  computed: {
    active() { return this.inspection.eligible && this.inspection.mode !== 'preview' && !!this.inspection.target },
    targetLabel() { return this.inspection.target && this.inspection.target.label || 'Sélection en cours' },
    validChecks() { return this.checks.filter(check => normalizeInspectionCheck(check)) },
    presentation() { return inspectionPresentation(this.validChecks, this.inspection.results) },
    accessibleLabel() { return [this.label, this.targetLabel, ...this.presentation.lines].filter(Boolean).join('. ') },
  },
  watch: {
    checks: { handler(checks) { rightsInspection.register(this.owner, checks) }, immediate: true, deep: true },
    active(active) { if (!active) this.opened = false },
  },
  beforeDestroy() { rightsInspection.unregister(this.owner) },
}
</script>

<style scoped>
.rights-indicator { display: inline-flex; vertical-align: middle; flex: 0 0 auto; margin-left: 5px; border-radius: 5px; }
.rights-indicator--warning { background: rgba(245, 158, 11, .12); outline: 1px solid rgba(245, 158, 11, .42); }
.rights-indicator__button { display: inline-flex; align-items: center; position: relative; padding: 2px 3px; border-radius: 4px; min-width: 23px; min-height: 23px; }
.rights-indicator__button:focus-visible { outline: 2px solid currentColor; outline-offset: 2px; }
.rights-indicator__person { margin-left: 1px; }
.rights-indicator__tooltip { font-size: 12px; line-height: 1.5; white-space: normal; }
</style>
